module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Content_Browser', {

		configure: function(options) {
			this.registerOptions('', {
				sendTimezone: true,
				dlMethod: 'content.load'
			});
			this.callParent('configure', arguments);
		},

		initDl: function() {
			this.callParent('initDl', arguments)
			
			if (!this.dl) {
				var dl = this.getOption('dataLayer');
				this.dl = fox.createDataLayer().set(dl || {});
			}
			
			if (this.getOption('preset') != 'favorites') {
				this.dl.setOption('cacheChannel', 'content');
			}

			if (!this.dl._transitParameters) {
				debugger;
			}

			var preset = this.getOption('preset');

			if (preset) {
				this.applyPreset(preset);
			}

		},

		init: function() {
			if (this.getOption('mixedContent') === true) {
				var contentRow = {
					0: 'row',
					1: 'dvd',
					2: 'scene',
					3: 'scene',
					20: 'scene', //liveshow
					11: 'photoset'
				};
				
				this.registerOptions('#list', {
					hooks: {
						onRendering: function(obj) {
							this.fragment = this.createFragment();
							while (obj = this.dl.iterateObject('mix')) {
								var rowTpl = this.getOption('tpl.' + contentRow[obj.get('contentType')]) ||
										this.getOption('tpl.row');
								this.fragment.appendChild(fox.Zen(rowTpl, [obj]));
							}
							return true;
						},
						onInitTpl: function() {
							fox.each(this.requireOption('tpl'), function(row, alias) {
								var tmp = fox.Zen(row, 'prepare');
								this.plainVariables = fox.merge(this.plainVariables, tmp.plainVariables);
							}, this);
						}
					}
				});
			}

			this.callParent('init', arguments);
			return this;
		},

		applyPreset: function(preset) {
			var method = (preset !== 'favorites') ? this.getOption('dlMethod') : 'favorite.get';
			this.dl.setMethod(method);
			this.dl.setTransitParameter('preset', this.getOption('preset'));

			return this;
		},

		filter: function(filter) {
			filter.filter.type = 'list' + fox.ucfirst(filter.subject);
			this.dl.setMethod('content.get');
			this.dl.setOffset(0).setTransitParameter('preset', 'search').setCustomFilter(filter.filter).addSorting('sites.publishDate', 'desc', 'lastadded').load();
		},

		setTags: function (tags) {
			this.dispatchEvent('tagsApplied', tags);

			if (tags.length) {
				this.dl.setTransitParameter('tags', tags.join(','));

				return;
			};

			this.dl.clearTransitParameters('tags');
		},

		applyTagsFilter: function (tags) {
			this.dl.setOffset(0);
			this.dl.setCp(1);

			this.setTags(tags);
		},

		filterByTags: function (tags) {
			this.applyTagsFilter(tags);
			this.dl.load();
		},

		generateContentLink: function () {
			var pm = this.wom1('@root .PermissionManager');

			var contentTypes = {
				3: 'scene',
				20: 'scene', //liveshow
				11: 'gallery'
			};

			fox.each(this.dl.getCollection(), function (data) {
				var accessibility = fox.objectGet(data.accessibility, ['collection', data.id])
				var arr = [];

				if (!contentTypes[data.contentType]) {
					console.warn('no such content type for direct link')
				}

				arr = ['/', contentTypes[data.contentType], '/', data.id];

				if (fox.isSet(data.title)) {
					var title = data.title.toString();
					arr.push('/')
					arr.push(fox.utils.toNavigatorAlias(title));
				};

				if (pm) {
					if (!pm.hasAccess('member') && accessibility.previewsForGuests === 0 && data.contentType == 11) {
						arr = [fox.getEnv('siteProps.ubs.joinUrl')];
					}
				} else if (!fox.site.member && accessibility.previewsForGuests === 0 && data.contentType == 11) {
					arr = [fox.getEnv('siteProps.ubs.joinUrl')];
				}

				data.generatedContentLink = arr.join('');
			}, this);
		}

	}, 'Grid');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/content/browser.js
// module id = 442
// module chunks = 4